/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleSourceData } from './SingleSourceData';
import {
    SingleSourceDataFromJSON,
    SingleSourceDataFromJSONTyped,
    SingleSourceDataToJSON,
    SingleSourceDataToJSONTyped,
} from './SingleSourceData';

/**
 * 
 * @export
 * @interface StatisticsBySource
 */
export interface StatisticsBySource {
    /**
     * 
     * @type {SingleSourceData}
     * @memberof StatisticsBySource
     */
    topChannel1?: SingleSourceData | null;
    /**
     * 
     * @type {SingleSourceData}
     * @memberof StatisticsBySource
     */
    topChannel2?: SingleSourceData | null;
    /**
     * 
     * @type {SingleSourceData}
     * @memberof StatisticsBySource
     */
    topChannel3?: SingleSourceData | null;
    /**
     * 
     * @type {SingleSourceData}
     * @memberof StatisticsBySource
     */
    otherChannels?: SingleSourceData | null;
    /**
     * SingleSourceData>
     * @type {{ [key: string]: SingleSourceData; }}
     * @memberof StatisticsBySource
     */
    topMarketingChannelsWithoutOtherCategories?: { [key: string]: SingleSourceData; };
    /**
     * SingleSourceData>
     * @type {{ [key: string]: SingleSourceData; }}
     * @memberof StatisticsBySource
     */
    topOtherCategoriesChannels?: { [key: string]: SingleSourceData; };
}

/**
 * Check if a given object implements the StatisticsBySource interface.
 */
export function instanceOfStatisticsBySource(value: object): value is StatisticsBySource {
    return true;
}

export function StatisticsBySourceFromJSON(json: any): StatisticsBySource {
    return StatisticsBySourceFromJSONTyped(json, false);
}

export function StatisticsBySourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsBySource {
    if (json == null) {
        return json;
    }
    return {
        
        'topChannel1': json['topChannel1'] == null ? undefined : SingleSourceDataFromJSON(json['topChannel1']),
        'topChannel2': json['topChannel2'] == null ? undefined : SingleSourceDataFromJSON(json['topChannel2']),
        'topChannel3': json['topChannel3'] == null ? undefined : SingleSourceDataFromJSON(json['topChannel3']),
        'otherChannels': json['otherChannels'] == null ? undefined : SingleSourceDataFromJSON(json['otherChannels']),
        'topMarketingChannelsWithoutOtherCategories': json['topMarketingChannelsWithoutOtherCategories'] == null ? undefined : (mapValues(json['topMarketingChannelsWithoutOtherCategories'], SingleSourceDataFromJSON)),
        'topOtherCategoriesChannels': json['topOtherCategoriesChannels'] == null ? undefined : (mapValues(json['topOtherCategoriesChannels'], SingleSourceDataFromJSON)),
    };
}

export function StatisticsBySourceToJSON(json: any): StatisticsBySource {
    return StatisticsBySourceToJSONTyped(json, false);
}

export function StatisticsBySourceToJSONTyped(value?: StatisticsBySource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'topChannel1': SingleSourceDataToJSON(value['topChannel1']),
        'topChannel2': SingleSourceDataToJSON(value['topChannel2']),
        'topChannel3': SingleSourceDataToJSON(value['topChannel3']),
        'otherChannels': SingleSourceDataToJSON(value['otherChannels']),
        'topMarketingChannelsWithoutOtherCategories': value['topMarketingChannelsWithoutOtherCategories'] == null ? undefined : (mapValues(value['topMarketingChannelsWithoutOtherCategories'], SingleSourceDataToJSON)),
        'topOtherCategoriesChannels': value['topOtherCategoriesChannels'] == null ? undefined : (mapValues(value['topOtherCategoriesChannels'], SingleSourceDataToJSON)),
    };
}

